<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>

      <report-field :field-name="$t(reportParameters[1].label)">
        <treeselect
          v-model="reportParameters[1].value"
          :options="networkStartingPointOptions"
          :load-options="getNetworkStartingPointOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              technicalSiteLocalDisabled ||
              !userHasPermissionToList('technical_local')
          "
          :disable-branch-nodes="true"
          disableFuzzyMatching
        />
      </report-field>

      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="typeOptions"
          :load-options="loadTypeOptions"
          value-format="object"
          :disabled="
            !hasPermissionToCreateExport || selectedWorkspace === undefined
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";
import ReportField from "@/components/Home/Content/Tabs/Reports/ReportField";
import ReportPage from "@/components/Home/Content/Tabs/Reports/ReportPage";
import { mapActions } from "vuex";

export default {
  name: "WorkPacksReport",
  components: {
    ReportField,
    ReportPage
  },
  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "Type",
          key: "type",
          type: "text",
          value: undefined
        },
        {
          label: "NetworkStartingPoint",
          key: "technical_local",
          type: "text",
          value: undefined
        }
      ],

      typeOptions: null,

      historyFilter: ""
    };
  },

  computed: {
    buttonsDisabled() {
      return (
        this.reportParameters[0].value === undefined ||
        this.reportParameters[1].value === undefined
      );
    },

    technicalSiteLocalDisabled() {
      return this.selectedWorkspace === undefined;
    },

    dataToSend() {
      let type = this.reportParameters[0].value;
      if (type !== undefined) {
        return {
          type: type.type,
          version: type.id,
          objects: {
            workspace_uuid: this.selectedWorkspace,
            object: {
              uuid: this.reportParameters[1].value,
              object_type: "technical_local"
            }
          }
        };
      } else return {};
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);

      this.typeOptions = null;
      this.networkStartingPointOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    ...mapActions(["GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE"]),
    /**
     * Loads the list of types of file available for the selected workspace.
     */
    async loadTypeOptions() {
      let historyFilters = [];
      if (this.selectedWorkspace) {
        try {
          let types = await this.GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE(
            "WorkPacks"
          );
          this.typeOptions = [];
          for (const type of Object.values(types)) {
            if (!type.disabled) {
              this.typeOptions.push({
                id: type.version,
                label: type.name,
                version: type.version,
                type: type.type,
                layers: type.layers,
                just_select_one: type.just_select_one,
                need_select_objects: type.need_select_objects
              });

              historyFilters.push(type.type);
            }
          }

          this.historyFilter = historyFilters.join(",");
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/WorkPacks.vue